import { create } from 'zustand';

import { OrganizationBranding } from '../types';

interface BrandingState {
  /** Current organization branding, or null if not loaded / using defaults. */
  branding: OrganizationBranding | null;
  setBranding: (branding: OrganizationBranding | null) => void;
}

/**
 * Holds the active organization's white-label branding so both the runtime
 * applier (useApplyBranding) and consumers like AppHeader read a single source.
 * Not persisted — it is reloaded from the API on each app start.
 */
export const useBrandingStore = create<BrandingState>((set) => ({
  branding: null,
  setBranding: (branding) => set({ branding }),
}));
